module.exports = __webpack_public_path__ + "img/om.957fa2cc.svg";